"use client";
import React from "react";
import { IoIosFlash } from "react-icons/io";
// import { useRouter } from "next/navigation";
import styles from "./ClinicalExams.module.css";
import { useNavigate } from "react-router-dom";

const ClinicalExamsFeature = () => {
  const navigation = useNavigate();

  return (
    <section className={styles.heroSection} style={{ minWidth: "100%" }}>
      <button
        style={{
          background: "linear-gradient(to right, #E3AF61, #8C43C7)",
          height: "50px",
          color: "white",
        }}
        onClick={() =>
          window.open("https://clinicalexams.medscroll.ai/", "_blank")
        }
      >
        New Feature
      </button>
      <div className={styles.heroContent}>
        <div className={styles.leftImage}>
          <img
            src="/images/hero-img-2.png"
            alt="logo"
            width={152}
            height={152}
          />
        </div>
        <div className={styles.heroText}>
          <div className={styles.flashRow}>
            <IoIosFlash className={styles.flashIcon} />
            <p className={styles.gradientText}>
              The Smarter, More Interactive Way to Prepare for Your Clinical
              Exams
            </p>
          </div>
          <h3 className={styles.mobileTitle}>
            MedScroll RACP Clinical Exam Course
          </h3>
          <h3 className={styles.desktopTitle}>
            MedScroll RACP Clinical Exam <br /> Course
          </h3>
          <p className={styles.description}>
            Preparing for the high-stakes RACP Clinical Exam can be daunting.
            Traditional study methods often fall short in providing the realism,
            structured feedback, and adaptability you need. MedScroll changes
            the game by offering AI-driven virtual patients, automated grading,
            and immersive simulations that transform the way you practice,
            refine, and perfect your clinical skills—anytime, anywhere.
          </p>
          {/* <Button
            label="Get started for free"
            onClick={() => router.push("/auth/signup")}
            className={styles.ctaButton}
          /> */}
          <button
            className="feature__case-recall-item__btn-colored"
            onClick={() =>
              window.open("https://clinicalexams.medscroll.ai/", "_blank")
            }
          >
            Get started for free
          </button>
        </div>
        <div className={styles.rightImage}>
          <img
            src="/images/hero-img-1.png"
            alt="logo"
            width={152}
            height={152}
          />
        </div>
      </div>

      <ul className={styles.heroItems}>
        {heroItems.map((item) => (
          <li key={item.id} className={styles.heroItem}>
            <div className={styles.mediaWrapper}>
              {item.type === "image" ? (
                <img
                  src={item.image}
                  alt={item.name}
                  className={styles.media}
                  width={500}
                  height={500}
                />
              ) : (
                <video
                  src={item.image}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className={styles.media}
                />
              )}
              <div className={styles.mediaText}>
                <h4>{item.name}</h4>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ClinicalExamsFeature;

const heroItems = [
  {
    id: 1,
    image: "/images/hero-video.mp4",
    name: "AI-Powered Virtual Patients",
    type: "video",
  },
  {
    id: 2,
    image: "/images/hero-img-4.png",
    name: "Simulate MEDSCROLL RACP Clinical Exam",
    type: "image",
  },
  {
    id: 3,
    image: "/images/hero-img-5.png",
    name: "Real-Time Feedback",
    type: "image",
  },
];
